import { useNovoTipoObraDialog } from "./use-novo-tipo-obra-dialog";
import { NovoTipoObraDialogView } from "./view-novo-tipo-obra-dialog";
import type { NovoTipoObraDialogProps } from "./types-novo-tipo-obra-dialog";

export function NovoTipoObraDialog(props: NovoTipoObraDialogProps) {
  const vm = useNovoTipoObraDialog(props);

  return <NovoTipoObraDialogView {...vm} />;
}

export type * from "./types-novo-tipo-obra-dialog";
